import React, { useRef, useLayoutEffect } from 'react';
import { Textarea } from '@chakra-ui/react';

export function AutoResizeTextarea(props: React.ComponentPropsWithRef<typeof Textarea>) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  }, [props.value]);

  return (
    <Textarea
      ref={ref}
      {...props}
      rows={1}
      resize="none"
      overflow="hidden"
      minH="unset"
    />
  );
}
